<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g id="icon">
        <path
          d="M17.1732 16.5753L17.994 7.17673C18.069 6.31841 17.4337 5.56129 16.5756 5.48607L14.2779 5.2847L14.804 11.317C14.9289 12.7476 13.871 14.0094 12.4407 14.1347L4.89481 14.7961L4.8343 15.4939C4.75934 16.3522 5.39411 17.1093 6.25229 17.1845L15.4836 17.994C16.342 18.069 17.0982 17.4338 17.1732 16.5753Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.1555 10.822L12.3438 1.42614L12.3436 1.42425C12.2684 0.565773 11.5116 -0.0691771 10.6532 0.00605093L1.42402 0.814927C0.566416 0.890091 -0.0682281 1.64583 0.00588353 2.50367L0.817616 11.8995L0.817789 11.9014C0.893005 12.7599 1.6498 13.3949 2.50815 13.3196L11.7373 12.5107C12.595 12.4356 13.2296 11.6798 13.1555 10.822ZM3.09881 4.83121C3.19731 4.8522 3.2995 4.86324 3.40427 4.86324C4.21004 4.86324 4.86324 4.21004 4.86324 3.40427C4.86324 2.5985 4.21004 1.9453 3.40427 1.9453C2.5985 1.9453 1.9453 2.5985 1.9453 3.40427C1.9453 3.90407 2.19662 4.34518 2.57978 4.60811C2.72632 4.72689 2.90507 4.80608 3.09881 4.83121ZM8.17015 6.51674C8.17015 7.32251 7.51695 7.97571 6.71118 7.97571C5.90541 7.97571 5.2522 7.32251 5.2522 6.51674C5.2522 5.71097 5.90541 5.05777 6.71118 5.05777C7.51695 5.05777 8.17015 5.71097 8.17015 6.51674ZM10.2128 10.6991C11.0186 10.6991 11.6718 10.0459 11.6718 9.24016C11.6718 8.43439 11.0186 7.78118 10.2128 7.78118C9.40704 7.78118 8.75383 8.43439 8.75383 9.24016C8.75383 10.0459 9.40704 10.6991 10.2128 10.6991Z"
        />
      </g>
    </g>
  </svg>
</template>
